import { List, fromJS } from 'immutable'

const SET_WIZARD_LIST = 'dofe-web/SET_WIZARD_LIST'
const SET_WIZARD_DONE = 'dofe-web/SET_WIZARD_DONE'
const SET_ACTIVE_STEP = 'dofe-web/SET_ACTIVE_STEP'
const SET_WIZARD_NEXT = 'dofe-web/SET_WIZARD_NEXT'

const initialState = fromJS({
  steps: List([])
})

export default function reducer(state = initialState, action = {}) {
  // if immutable eg it's sent from window.__data__
  if (!state.size) {
    state = fromJS(state)
  }

  const steps = state.get('steps')

  switch (action.type) {
    case SET_WIZARD_LIST:
      return state.update('steps', () => List(action.steps))

    case SET_WIZARD_DONE:
      return state.update('steps', () => {
        return steps.update(steps.findIndex(item => {
          return item.id === action.id
        }), obj => ({
          ...obj,
          completed: action.bool
        }))
      })

    case SET_ACTIVE_STEP:
      // return fromJS({
      //   ...state,
      //   steps: steps.update(steps.findIndex(item => {
      //     return item.id === action.id
      //   }), obj => ({
      //     ...obj,
      //     active: action.bool
      //   }))
      // })
      return state.update('steps', () => {
        return steps.update(steps.findIndex(item => {
          return item.id === action.id
        }), obj => ({
          ...obj,
          active: action.bool
        }))
      })
    case SET_WIZARD_NEXT:
      return state.update('steps', () => {
        return steps.update(steps.findIndex(item => {
          return item.id === action.id
        }), obj => ({
          ...obj,
          next: action.path
        }))
      })
    default:
      return state
  }
}

export function setWizard(steps) {
  return {
    type: SET_WIZARD_LIST,
    steps
  }
}

export function setWizardCompleted(id, bool) {
  return {
    type: SET_WIZARD_DONE,
    id,
    bool
  }
}

export function changeWizardActive(id, bool) {
  return {
    type: SET_ACTIVE_STEP,
    id,
    bool
  }
}

export function changeWizardNext(id, path) {
  return {
    type: SET_WIZARD_NEXT,
    id,
    path
  }
}
